module.exports = __webpack_public_path__ + "img/Moduuli_2_liiketoimintamalli_uudet_asiakkaat.8af88509.png";